module.exports = __webpack_public_path__ + "static/media/8.99e769c9.jpg";